import { FunctionalComponent, h } from '@stencil/core';
import { AppOffsetGalleryItem } from './'

interface SectionOffsetGallery {
  __component: string;
  data?: any;
}


export const SectionOffsetGallery: FunctionalComponent<SectionOffsetGallery> = ({ data }) => {


  const { Title, Subtitle, Items } = data

  return (
    <section class="uk-section uk-margin-large-top uk-position-relative uk-padding-remove-top uk-container uk-text-center">
      <div class="uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@l uk-grid-small" uk-grid="masonry: true">
        <div class="uk-text-left">
          <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">{Subtitle}</h2>
          <h3 class="uk-heading-xlarge wsio-darker-green uk-margin-remove-top uk-margin-medium-bottom">{Title}</h3>
        </div>
        {Items.map(({ Title, Media, Link, Description }, i) => <AppOffsetGalleryItem Title={Title} Media={Media} Link={Link} Description={Description} Index={i} />)}
      </div>
    </section>)
};